<template>
  <main-content>
    <b-card>
      <ERegistrationHeaderFormInfo />
      <ERegistrationHelperRegisterForm v-if="iamsmartSession==null" :invitation-key="invitationKey" :businessId="businessId" :iamsmart-session="iamsmartSession"/>
      <!-- <ERegistrationHelperRegisterIAmSmartForm v-else :invitation-key="invitationKey" :businessId="businessId" :iamsmart-session="iamsmartSession" :userEngName="userEngName"/> -->
      <ERegistrationHelperRegisterIAmSmartForm v-else :invitation-key="invitationKey" :businessId="businessId" :iamsmart-session="iamsmartSession"/>
    </b-card>
  </main-content>
</template>

<script>
import ERegistrationHelperRegisterForm from "../components/e-registration-helper-register/ERegistrationHelperRegisterForm";
import ERegistrationHelperRegisterIAmSmartForm from "../components/e-registration-helper-register/ERegistrationHelperRegisterIAmSmartForm";
import ERegistrationHeaderFormInfo from "../components/e-registration-header-form/ERegistrationHeaderFormInfo"
import { IAmSmartQrCodeApi } from '@/api';

export default {
  props: {
    invitationKey: {
      type: String
    },
    businessId :{
      type: String
    },
    userEngName:{
      type: String
    }
  },
  components: {
    ERegistrationHeaderFormInfo,
    ERegistrationHelperRegisterIAmSmartForm,
    ERegistrationHelperRegisterForm
  },
  async beforeRouteEnter(to, _from, next) {
    const { businessId } = to.params;
    const iamsmartSession = (await IAmSmartQrCodeApi.getSession(businessId)).data;

    if (businessId) {
      next((vm) => {
        vm.iamsmartSession = iamsmartSession;
      });
    } else {
      next();
    }
  },
  data() {
    return {
      iamsmartSession: null
    }
  }
};
</script>

<style lang="scss" scoped></style>
